/** Matches QuizModal / server scoring: comments and page separators are not counted as questions. */

const QUIZ_COMMENT_MARKER = '__COMMENT__';
const QUIZ_PAGE_SEPARATOR_MARKER = '__PAGE_SEPARATOR__';

/** Non-answerable vs answerable rows in quiz/exercise question lists (server RowKind). */
export enum QuizExerciseRowKind {
  Answerable = 0,
  Comment = 1,
  PageSeparator = 2,
}

export type QuizQuestionLike = {
  question?: string;
  textContent?: string;
  textContentFa?: string;
  rowKind?: QuizExerciseRowKind | number;
};

export function isPageSeparatorQuestion(q: QuizQuestionLike): boolean {
  if (q?.rowKind === QuizExerciseRowKind.PageSeparator) return true;
  return (
    q?.question === QUIZ_PAGE_SEPARATOR_MARKER ||
    q?.textContent === QUIZ_PAGE_SEPARATOR_MARKER ||
    q?.textContentFa === QUIZ_PAGE_SEPARATOR_MARKER
  );
}

export function isCommentQuestion(q: QuizQuestionLike): boolean {
  if (q?.rowKind === QuizExerciseRowKind.Comment) return true;
  if (q?.question === QUIZ_COMMENT_MARKER) return true;
  for (const tc of [q?.textContent, q?.textContentFa]) {
    if (!tc) continue;
    if (tc === QUIZ_COMMENT_MARKER) return true;
    if (tc.startsWith(`${QUIZ_COMMENT_MARKER}\n`)) return true;
  }
  return false;
}

export function countAnswerableQuizQuestions(questions: QuizQuestionLike[] | undefined): number {
  if (!questions?.length) return 0;
  return questions.filter((q) => !isPageSeparatorQuestion(q) && !isCommentQuestion(q)).length;
}

export function formatQuizTimeLimitLabel(minutes: number | undefined): string {
  if (minutes == null || minutes === 0) return 'no time limit';
  return `${minutes} min`;
}
